module.exports = __webpack_public_path__ + "media/images/flags/BF-fc6bd6c8bd67fdc9149f2df75391dc0e.svg";